import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "../../../api/axios";
import useAuth from "../../../hooks/useAuth";
import { LOGIN_URL } from "../../../constants/ApiUrls";
const Login = () => {
  const { auth, setAuth } = useAuth();
  const Nav = useNavigate();
  useEffect(() => {
    document.title = "Snilink - Login";
    if (auth.username) {
      Nav("/");
    }
  }, []);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isShow, setIsShow] = useState(false);
  const handleShowPassword = () => {
    setIsShow(!isShow);
  };
  const [errMsg, setErrMsg] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/dashboard";
  const handleSubmit = async (e) => {
    setErrMsg("");
    try {
      const response = await axios.post(
        LOGIN_URL,
        JSON.stringify({ user: username, pwd: password }),
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );
      const accessToken = response?.data?.accessToken;
      const roles = response?.data?.roles;
      const email = response?.data?.email;
      const avatar = response?.data?.avatar;
      const userId = response?.data?.userId;
      setAuth({
        userId,
        username,
        email,
        avatar,
        roles,
        accessToken,
      });
      setUsername("");
      setPassword("");
      navigate(from, { replace: true });
    } catch (err) {
      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.status === 400) {
        setErrMsg("Missing Username or Password");
      } else if (err.response?.status === 401) {
        setErrMsg("Password not valide");
      } else if (err.response?.status === 404) {
        setErrMsg("Username not found");
      } else {
        setErrMsg("Login Failed");
      }
    }
  };
  return (
    <>
      <section className="min-h-screen pt-64px flex box-border dark:bg-accent-900">
        <div className="m-auto  w-full max-w-md box-border">
          <form className="my-48px box-border max-w-md w-full bg-white dark:bg-accent-800 dark:border-none shadow-none sm:shadow-md flex  flex-col rounded-xl sm:border sm:border-accent-50 relative overflow-hidden p-48px">
            <h1 className="m-0 mb-10px text-3xl font-bold text-primary-900 dark:text-accent-100">
              Login
            </h1>
            <p className="m-0 mb-20px text-lg text-accent-400 dark:text-accent-200">
              Welcome back !
            </p>
            {errMsg && (
              <div className="text-sm bg-red-200 text-red-700 py-2 px-4 mb-20px rounded-lg">
                {errMsg}
              </div>
            )}
            <div className="flex flex-col gap-8px text-sm mb-20px">
              <label className="text-accent-300" htmlFor="username">
                Username
              </label>
              <div className="flex focus-within:outline-primary-500 outline-1 focus-within:outline w-full font-medium box-border rounded-lg border border-accent-200 dark:border-accent-500 shadow-sm overflow-hidden text-primary-800">
                <div className=" flex items-center px-3">
                  <svg
                    width="21"
                    height="21"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_84_10578"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="24"
                      height="24"
                    >
                      <rect width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_84_10578)">
                      <path
                        d="M12 12C10.9 12 9.95833 11.6083 9.175 10.825C8.39167 10.0417 8 9.1 8 8C8 6.9 8.39167 5.95833 9.175 5.175C9.95833 4.39167 10.9 4 12 4C13.1 4 14.0417 4.39167 14.825 5.175C15.6083 5.95833 16 6.9 16 8C16 9.1 15.6083 10.0417 14.825 10.825C14.0417 11.6083 13.1 12 12 12ZM4 20V17.2C4 16.6333 4.14583 16.1125 4.4375 15.6375C4.72917 15.1625 5.11667 14.8 5.6 14.55C6.63333 14.0333 7.68333 13.6458 8.75 13.3875C9.81667 13.1292 10.9 13 12 13C13.1 13 14.1833 13.1292 15.25 13.3875C16.3167 13.6458 17.3667 14.0333 18.4 14.55C18.8833 14.8 19.2708 15.1625 19.5625 15.6375C19.8542 16.1125 20 16.6333 20 17.2V20H4ZM6 18H18V17.2C18 17.0167 17.9542 16.85 17.8625 16.7C17.7708 16.55 17.65 16.4333 17.5 16.35C16.6 15.9 15.6917 15.5625 14.775 15.3375C13.8583 15.1125 12.9333 15 12 15C11.0667 15 10.1417 15.1125 9.225 15.3375C8.30833 15.5625 7.4 15.9 6.5 16.35C6.35 16.4333 6.22917 16.55 6.1375 16.7C6.04583 16.85 6 17.0167 6 17.2V18ZM12 10C12.55 10 13.0208 9.80417 13.4125 9.4125C13.8042 9.02083 14 8.55 14 8C14 7.45 13.8042 6.97917 13.4125 6.5875C13.0208 6.19583 12.55 6 12 6C11.45 6 10.9792 6.19583 10.5875 6.5875C10.1958 6.97917 10 7.45 10 8C10 8.55 10.1958 9.02083 10.5875 9.4125C10.9792 9.80417 11.45 10 12 10Z"
                        fill="#8388A0"
                      />
                    </g>
                  </svg>
                </div>
                <input
                  className="outline-none py-10px px-16px w-full bg-transparent box-border border-none font-semibold text-primary-800 dark:text-accent-200 dark:placeholder:text-accent-400 text-base"
                  autoComplete="off"
                  required
                  type="text"
                  placeholder="username"
                  id="username"
                  value={username}
                  onChange={(event) => setUsername(event.target.value)}
                />
              </div>
            </div>
            <div className="flex flex-col gap-8px text-sm mb-20px">
              <label className="text-accent-300" htmlFor="password">
                Password
              </label>
              <div className="flex focus-within:outline-primary-500 outline-1 focus-within:outline w-full font-medium box-border rounded-lg border border-accent-200 dark:border-accent-500 shadow-sm overflow-hidden text-primary-800">
                <div className="flex items-center px-3">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_76_10470"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="24"
                      height="24"
                    >
                      <rect width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_76_10470)">
                      <path
                        d="M6 21C5.45 21 4.97917 20.8042 4.5875 20.4125C4.19583 20.0208 4 19.55 4 19V9C4 8.45 4.19583 7.97917 4.5875 7.5875C4.97917 7.19583 5.45 7 6 7H7V5C7 3.61667 7.4875 2.4375 8.4625 1.4625C9.4375 0.4875 10.6167 0 12 0C13.3833 0 14.5625 0.4875 15.5375 1.4625C16.5125 2.4375 17 3.61667 17 5V7H18C18.55 7 19.0208 7.19583 19.4125 7.5875C19.8042 7.97917 20 8.45 20 9V19C20 19.55 19.8042 20.0208 19.4125 20.4125C19.0208 20.8042 18.55 21 18 21H6ZM6 19H18V9H6V19ZM12 16C12.55 16 13.0208 15.8042 13.4125 15.4125C13.8042 15.0208 14 14.55 14 14C14 13.45 13.8042 12.9792 13.4125 12.5875C13.0208 12.1958 12.55 12 12 12C11.45 12 10.9792 12.1958 10.5875 12.5875C10.1958 12.9792 10 13.45 10 14C10 14.55 10.1958 15.0208 10.5875 15.4125C10.9792 15.8042 11.45 16 12 16ZM9 7H15V5C15 4.16667 14.7083 3.45833 14.125 2.875C13.5417 2.29167 12.8333 2 12 2C11.1667 2 10.4583 2.29167 9.875 2.875C9.29167 3.45833 9 4.16667 9 5V7Z"
                        fill="#8388A0"
                      />
                    </g>
                  </svg>
                </div>
                <input
                  className="outline-none py-10px px-16px w-full bg-transparent box-border border-none font-semibold text-primary-800 dark:text-accent-200 dark:placeholder:text-accent-400 text-base"
                  autoComplete="off"
                  required
                  type={`${isShow ? "text" : "password"}`}
                  placeholder="*********"
                  id="password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                />
              </div>
            </div>
            <div className="flex items-center mb-20px gap-16px text-accent-400">
              <label className="customized-checkbox">
                <input
                  type="checkbox"
                  checked={isShow}
                  onChange={handleShowPassword}
                  id="show-password"
                />
                <svg viewBox="0 0 21 18">
                  <symbol
                    id="tick-path"
                    viewBox="0 0 21 18"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.22003 7.26C5.72003 7.76 7.57 9.7 8.67 11.45C12.2 6.05 15.65 3.5 19.19 1.69"
                      fill="none"
                      strokeWidth="2.25"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </symbol>
                  <defs>
                    <mask id="tick">
                      <use className="tick mask" href="#tick-path" />
                    </mask>
                  </defs>
                  <use
                    className="tick"
                    href="#tick-path"
                    stroke="currentColor"
                  />
                  <path
                    fill="white"
                    mask="url(#tick)"
                    d="M18 9C18 10.4464 17.9036 11.8929 17.7589 13.1464C17.5179 15.6054 15.6054 17.5179 13.1625 17.7589C11.8929 17.9036 10.4464 18 9 18C7.55357 18 6.10714 17.9036 4.85357 17.7589C2.39464 17.5179 0.498214 15.6054 0.241071 13.1464C0.0964286 11.8929 0 10.4464 0 9C0 7.55357 0.0964286 6.10714 0.241071 4.8375C0.498214 2.39464 2.39464 0.482143 4.85357 0.241071C6.10714 0.0964286 7.55357 0 9 0C10.4464 0 11.8929 0.0964286 13.1625 0.241071C15.6054 0.482143 17.5179 2.39464 17.7589 4.8375C17.9036 6.10714 18 7.55357 18 9Z"
                  />
                </svg>
                <svg className="lines" viewBox="0 0 11 11">
                  <path d="M5.88086 5.89441L9.53504 4.26746" />
                  <path d="M5.5274 8.78838L9.45391 9.55161" />
                  <path d="M3.49371 4.22065L5.55387 0.79198" />
                </svg>
              </label>
              <label htmlFor="show-password">Show password</label>
            </div>
            <button
              type="button"
              className="w-full p-12px font-medium rounded-lg bg-primary-500 text-white mb-20px"
              onClick={() => handleSubmit()}
            >
              Login
            </button>
            <button
              type="button"
              onClick={() => {
                Nav("/reset");
              }}
              className="w-full p-12px font-medium rounded-lg border border-primary-500 bg-transparent text-primary-500"
            >
              Forgot password
            </button>
          </form>
        </div>
      </section>
    </>
  );
};

export default Login;
